import {
   Box,
   Checkbox,
   FormControl,
   FormControlLabel,
   FormHelperText,
   Typography,
} from '@mui/material';
import { Interweave } from 'interweave';
import { useState } from 'react';
import { withFirebase } from '../../Firebase';
import ConfirmationImage from '../Settings/confirmationImage';

const HostFound = ({
   host,
   setStatus,
   setLoading,
   unannouncedVisitor,
   form,
   lid,
   locationName,
   customisations,
   clearForm,
   confirmed,
   setConfirmed,
   confirmationStatementCheckbox,
   setConfirmationStatementCheckbox,
   ...props
}) => {
   const [error, setError] = useState(false);

   return (
      <>
         {!confirmed && customisations !== null && (
            <Box>
               <Typography variant="h5" component="h2" align="center">
                  {customisations.confirmationPageTitle !== ''
                     ? customisations.confirmationPageTitle
                     : `Please confirm you have read and understood the policies below.`}
               </Typography>
               {customisations !== null &&
                  customisations.confirmationStatements.length > 0 && (
                     <Box
                        sx={{
                           m: 1,
                           maxHeight: '40vh',
                           overflow: 'scroll',
                           backgroundColor: '#fff',
                           border: '1px solid #ccc',
                           p: 1,
                        }}
                     >
                        {customisations.confirmationStatements.map((statement, index) => (
                           <Box key={index}>
                              {statement.type === 'image' ? (
                                 <ConfirmationImage path={statement.path} />
                              ) : (
                                 <Interweave content={statement.content} />
                              )}
                           </Box>
                        ))}
                     </Box>
                  )}
               <FormControl>
                  <FormControlLabel
                     control={
                        <Checkbox
                           checked={confirmationStatementCheckbox}
                           onChange={() => {
                              setConfirmationStatementCheckbox(
                                 !confirmationStatementCheckbox,
                              );
                              if (error) setError(false);
                           }}
                        />
                     }
                     label={
                        customisations.confirmationStatementWording !== ''
                           ? customisations.confirmationStatementWording
                           : `I confirm I have read and understood these policies.`
                     }
                  />

                  {error && (
                     <FormHelperText error={true}>
                        You must confirm to continue.
                     </FormHelperText>
                  )}
               </FormControl>

               {/* <Button
                  onClick={() => {
                     if (confirmationStatementCheckbox) {
                        setConfirmed(!confirmed);
                     } else {
                        setError(true);
                     }
                  }}
                  variant="contained"
               >
                  Confirm
               </Button> */}
            </Box>
         )}
         {confirmed && (
            <Box>
               <Typography variant="h5" component="h2" align="center">
                  Your host is {host.name}
               </Typography>
               <Typography variant="body1" component="p" align="center">
                  Please click on submit to alert your host(s).
               </Typography>
            </Box>
         )}
      </>
   );
};

export default withFirebase(HostFound);
